<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="名称" prop="name">
                <el-input v-model="ruleForm.name" placeholder="请输入动作名称"></el-input>
            </el-form-item>
            <el-form-item label="模型">
                <el-select v-model="ruleForm.data.url" placeholder="请选择模型">
                    <el-option v-for="item in typeOptions" :key="item.key" :label="item.label" :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="漫游时间(秒)">
                <el-input-number controls-position="right" :min="1" :step="0.5" v-model="ruleForm.data.time"></el-input-number>
            </el-form-item>
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" :disabled="drawDone"
                    @click="drawCoordinate">绘制</el-button>
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">创建</el-button>
                <!-- <el-button class="base-button" size="mini" @click="resetForm('ruleForm')">重置</el-button> -->
            </div>
        </el-form>
    </div>
</template>
<script>
import DrawHelper from "../lib/DrawPolyline.js"
let DrawUti = undefined;
import * as Help from "./help"
let plotArr = [];
export default {
    props: ["subData"],
    data() {
        return {
            typeOptions: [
            {
                    key: NG_Server+"/gisData/glb/Hoveringdrone.glb",
                    label: '无人机'
                },
                {
                    key: NG_Server+"/gisData/glb/Ambulance.glb",
                    label: '医疗车'
                },
                {
                    key: NG_Server+"/gisData/glb/feiji.glb",
                    label: '飞机'
                },
                {
                    key: NG_Server+"/gisData/glb/XinHaoTa.glb",
                    label: '信号塔'
                },
                {
                    key: NG_Server+"/gisData/glb/qi_dian_chuan.glb",
                    label: '气垫船'
                },
                {
                    key: NG_Server+"/gisData/glb/HangKongMuJian.glb",
                    label: '航空母舰'
                },
                {
                    key: NG_Server+"/gisData/glb/renA.glb",
                    label: '人员A'
                },
                {
                    key: NG_Server+"/gisData/glb/renB.glb",
                    label: '人员B'
                },
                {
                    key: NG_Server+"/gisData/glb/dao_dan_ting.glb",
                    label: '船只'
                },
                {
                    key: NG_Server+"/gisData/glb/xiaofangcheA.gltf",
                    label: '救援车A'
                },
                {
                    key: NG_Server+"/gisData/glb/launchvehicle.glb",
                    label: '导弹'
                }
            ],
            ruleForm: {
                name: "",
                type: "lineRoam",
                typeName: "线路漫游",
                delay: 1,
                data: {
                    url: NG_Server+"/gisData/glb/Hoveringdrone.glb",
                    time: 3
                },
                coordinate: "",
                params: {},
                view: {}
            },
            rules: {
                name: [
                    { required: true, message: "请选择围栏类型", trigger: "change" },
                ],
                coordinate: [{ required: true, message: "请绘制围栏范围", trigger: "blur" }]
            },
            drawDone: false,
        };
    },
    methods: {
        submitForm(formName) {
            console.log(this.ruleForm);
            this.ruleForm.view = Help.getCameraView();
            this.$bus.$emit("addActionObj", JSON.parse(JSON.stringify(this.ruleForm)));
            this.resetForm("ruleForm");
            this.$parent.close();
        },
        resetForm(formName) {
            DrawUti && DrawUti.clear();
            this.$refs[formName].resetFields();
            this.drawDone = false;
            // for (let i = 0; i < plotArr.length; i++) {
            //     viewer.entities.remove(plotArr[i]);
            // }
        },
        getPlot(plot) {
            this.ruleForm.coordinate = plot.polyline.positions.getValue();
            this.drawDone = true;

            var entity = Help.addGlb(this.ruleForm.data.url, this.ruleForm.coordinate[0]);
            // plotArr.push(entity);
            Help.addEntityArr(entity);
            this.$parent.reset();
        },
        drawCoordinate() {
            if (!DrawUti) {
                DrawUti = new DrawHelper({
                    canEdit: false,
                    callback: this.getPlot
                });
            }

            DrawUti.reset();
            DrawUti.start();
            this.$parent.min();
        }
    },
    created() {
    },
    mounted() { },
    beforeDestroy() {
        this.$refs['ruleForm'].resetFields();
        DrawUti && DrawUti.clear();
        DrawUti = undefined;
        for (let i = 0; i < plotArr.length; i++) {
            viewer.entities.remove(plotArr[i]);
        }
    }
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>